import React, { useEffect, useState } from 'react';
import { axiosGetCall, axiosPostCall } from '../../../services/apisCall';
import Logger from '../../../lib/Logger';
const logger = new Logger("kycListTable");
import { renderErrorMessage, renderSuccessMessage } from '../../../lib/toastMessage';
import { CustomMenu } from '../../../components/menu/customMenu';

import { PaginationTable } from '../../../components/tables/paginationTable';
// import TableFilters from './tableFilter';

import { TableCell, Box, List, ListItem, MenuItem, styled, useTheme, TextField, Button, Select} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { configFile } from '../../../config';
import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';
import { Icon } from '@iconify/react';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import { ConfirmDialog } from 'src/components/custom-dialog';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import DeleteIcon from '@mui/icons-material/Delete';

const columns = [
    
    { id: 'gateway_id', label: 'Gateway Id', minWidth: 110, align: 'center' },
    { id: 'name', label: 'Name', minWidth: 110, align: 'center' },
    { id: 'host_id', label: 'Host Id', minWidth: 110, align: 'center' },
    { id: 'host_ip', label: 'Host IP', minWidth: 110, align: 'center' },
    { id: 'route', label: 'Route', minWidth: 110, align: 'center' },
    { id: 'cli_type', label: 'Gateway Cli Type', minWidth: 110, align: 'center' },
    { id: 'channels', label: 'Channels', minWidth: 110, align: 'center' },
    { id: 'cli_prefix', label: 'CLI Prefix', minWidth: 110, align: 'center' },
    { id: 'gateway_pulse', label: 'Gateway Pulse', minWidth: 200, align: 'center' },
    { id: 'create_date', label: 'Create Date', minWidth: 110, align: 'center' },
    { id: 'is_dedicated', label: 'Dedicated', minWidth: 70, align: 'center' },
    { id: 'update_by', label: 'Update By', minWidth: 110, align: 'center' },
    { id: 'status', label: 'Status', minWidth: 150, align: 'center' },
    { id: 'actions', label: 'Actions', minWidth: 70, align: 'center' }
];

const CustomMenuItem = styled(MenuItem)(({ theme }) => ({
    // color: theme.palette.grey[200],
    gap: '8px'
}))

const menuItems = [
  { value: 0, label: 'Inactive'},
  { value: 1, label: 'Active'},
  { value: 2, label: 'Report Only'},
];


export const VoiceGatewayList = ({loadit, setUpdateUserId, forceLoad}) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const { URL_MAPPER: { console: consoleUrl } = {} } = configFile
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [rows, setRows] = useState([])
    const [count, setCount] = useState(0)

    const [search, setSearch] = useState("")
    const [load, setLoad] = useState(true)
    const [networkError, setNetworkError] = useState(false)
    const [loading, setLoading] = useState(true);
    const [openStatus, setOpenStatus] = useState(false);
    const [status , setStatus] = useState()
    const [userData, setUserData] = useState([]);
    const [openAssign, setOpenAssign] = useState(false);
    const [assign , setAssign] = useState()
    const [openTestGateway, setOpenTestGateway] = useState(false);
    const [openRemoveAssign, setOpenRemoveAssign] = useState(false);
    const [removeAssign, setRemoveAssign] = useState()
    const [openDelete, setOpenDelete] = useState(false);
    const { email } = jwtDecode(localStorage.getItem('token'));


    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);


    
    const handleChange = (value) => setSearch(value)
    
    const getGatewayList = async () => {
        const skip = rowsPerPage * page;
        try {
            const params = { skip, limit: rowsPerPage }
            if (search) params.gatewayId = search
            setNetworkError(false)
            const {  gatewayList, totalGatewayCount } = await axiosGetCall("getVoiceGatewayList", params)
            setRows(gatewayList);
            setCount(totalGatewayCount)
        } catch (error) {
            logger.error("Gateway List", error);
            setNetworkError(true)
            setRows([])
            setCount(0)
            renderErrorMessage(error?.message)
        }
        setLoading(false)
    }

    useEffect(() => {
        // if (load) {
            setLoading(true)
            getGatewayList()
            setLoad(false)
            forceLoad(false)

        // }
    }, [load,loadit])

    const handleClick = (event, user) => {
        setAnchorEl(event.currentTarget);
        setUserData(user);
    };
    const handleUpdateClick = () => {
        setAnchorEl(null);
        setUpdateUserId(userData.gateway_id);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleCloseStatus = () => {
         setAnchorEl(null);
        setOpenStatus(false);
        setStatus();
    };
    const handleStatusClick = () =>{
        setOpenStatus(true);
        setAnchorEl(null);
    };
        const handleAssignClick = () =>{
        setOpenAssign(true);
        setAnchorEl(null);
    }
    const handleCloseAssign = () => {
        setAnchorEl(null);
        setOpenAssign(false);
        setAssign();
    }
    const handleRemoveAssignClick = () =>{
        setOpenRemoveAssign(true);
        setAnchorEl(null);
    }
    const handleCloseRemoveAssign = () => {
        setAnchorEl(null);
        setOpenRemoveAssign(false);
        setRemoveAssign();
    }

    const handletestGateway = () => {
        setOpenTestGateway(true);
        setAnchorEl(null);
    }
    const handleDeleteClick = () => {
        setOpenDelete(true);
        setAnchorEl(null);
    };
    const handleCloseDelete = () => {
        setAnchorEl(null);
        setOpenDelete(false);
    };


    const handleConfirmStatus = async(gatewayId, status) => {
        try{
            const params = {
                gatewayId,
                newStatus: status,
            }
            const data = await axiosGetCall('changeGatewayStatus', params)
            renderSuccessMessage(data?.message)
            getGatewayList();
            setOpenStatus(false);
            setAnchorEl(null);
            setStatus();
        } catch (error) {
            logger.error("Gateway List change status", error);
            renderErrorMessage(error?.message)
        }
        
    }
    const handleConfirmAssign = async(gatewayId, assign) => {
        try{
            const params = {
                gatewayId,
                assignUserId: assign,
                action: "add",
            }
            const data = await axiosGetCall('assignVoiceGateway', params)
            renderSuccessMessage(data?.message)
            getGatewayList();
            setOpenAssign(false);
            setAnchorEl(null);
            setAssign();
        } catch (error) {
            logger.error("Gateway List change status", error);
            renderErrorMessage(error?.message)
        }
        
    }

        const handleConfirmRemoveAssign = async(gatewayId,) => {
        try{
            const params = {
                gatewayId,
                assignUserId: removeAssign,
                action: "removed",
            }
            const data = await axiosGetCall('assignVoiceGateway', params)
            renderSuccessMessage(data?.message)
            getGatewayList();
            setOpenRemoveAssign(false);
            setAnchorEl(null);
            setRemoveAssign();
        } catch (error) {
            logger.error("Gateway List change status", error);
            renderErrorMessage(error?.message)
        }
        
    }

    const handleConfirmDelete = async () => {
        try {
          const payload = {
            gatewayId: userData.gateway_id,
            adminEmail: email
          };
          const data = await axiosPostCall('deleteGateway', payload);
          renderSuccessMessage(data?.message);
          getGatewayList();
          setOpenDelete(false);
          setAnchorEl(null);
        } catch (error) {
          logger.error('Gateway List change status', error);
          renderErrorMessage(error?.message);
        }
    };


    // const tableFilter = <TableFilters search={search} handleChange={handleChange} setLoad={setLoad} count={count} setPage={setPage} />

    const ActionJsx = (id, align, value, ...other) => {
        const user = other[3]

        return (
            <TableCell
                key={id}
                align={align}
                sx={{
                    color: 'grey.400',
                    borderBottom: '0.5px dashed',
                    borderColor: 'grey.300',
                    size: 'small'
                }}>
                <MoreVertIcon
                    sx={{ color: 'grey.700', cursor: 'pointer', height: '18px', width: '18px' }}
                    aria-controls={open ? 'filters-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={(e) => handleClick(e, user)}
                />
            </TableCell>
        )
    }
    const Content = () => (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px'
        }}>
            <List>
                <ListItem sx={{
                    display: 'flex',
                    gap: '7px',
                    fontWeight: 400,
                    color: 'grey.700',
                    '&:hover': {
                        color: 'grey.800',
                        backgroundColor: 'grey.300',
                        cursor: "pointer"
                    }
                }}
                    onClick={handleStatusClick}
                >
                    <SwapHorizIcon sx={{ color: '#1976d2', height: '17px', margin: '5px' }} />
                    Change Status
                </ListItem>
                <ListItem sx={{
                    display: 'flex',
                    gap: '7px',
                    fontWeight: 400,
                    color: 'grey.700',
                    '&:hover': {
                        color: 'grey.800',
                        backgroundColor: 'grey.300',
                        cursor: "pointer"
                    }
                }}
                    onClick={handleUpdateClick}
                >
                    <Icon icon="lucide:edit" style={{ color: '#1976d2', height: '17px', margin: '5px' }} />
                    Update
                </ListItem>
                {userData.is_dedicated === "Y" && (
                <ListItem sx={{
                    display: 'flex',
                    gap: '7px',
                    fontWeight: 400,
                    color: 'grey.700',
                    '&:hover': {
                        color: 'grey.800',
                        backgroundColor: 'grey.300',
                        cursor: "pointer"
                    }
                }}
                    onClick={handleAssignClick}
                >
                    <AssignmentIndIcon sx={{ color: "#1976d2", height: "17px" }} />
                    assign to User
                </ListItem>
                )}
                {userData.is_dedicated === "Y" && (
                <ListItem sx={{
                    display: 'flex',
                    gap: '7px',
                    fontWeight: 400,
                    color: 'grey.700',
                    '&:hover': {
                        color: 'grey.800',
                        backgroundColor: 'grey.300',
                        cursor: "pointer"
                    }
                }}
                    onClick={handleRemoveAssignClick}
                >
                    <AssignmentIndIcon sx={{ color: "red", height: "17px" }} />
                    Remove assign to User
                </ListItem>
                )}
                {/* <ListItem sx={{
                    display: 'flex',
                    gap: '7px',
                    fontWeight: 400,
                    color: 'grey.700',
                    '&:hover': {
                        color: 'grey.800',
                        backgroundColor: 'grey.300',
                        cursor: "pointer"
                    }
                }}
                    onClick={handleUpdateClick}
                >
                    <Icon icon="mdi:queue" style={{ color: '#1976d2', height: '17px', margin: '5px' }} />
                    Create Gateway Queue
                </ListItem> */}
                <ListItem sx={{
                    display: 'flex',
                    gap: '7px',
                    fontWeight: 400,
                    color: 'grey.700',
                    '&:hover': {
                        color: 'grey.800',
                        backgroundColor: 'grey.300',
                        cursor: "pointer"
                    }
                }}
                onClick={() => {
                navigate('/voiceTestGateway', {
                    state: {
                    userData,
                    },
                });
                }}
                >
                    <Icon icon="carbon:gateway-api" style={{ color: '#1976d2', height: '17px', margin: '5px' }} />
                    Test Voice Gateway
                </ListItem> 
                 {userData.status !== 1 && (             
                <ListItem
                sx={{
                    display: 'flex',
                    gap: '7px',
                    fontWeight: 400,
                    color: 'grey.700',
                    '&:hover': {
                    color: 'grey.800',
                    backgroundColor: 'grey.300',
                    cursor: 'pointer',
                    },
                }}
                onClick={handleDeleteClick}
                >
                <DeleteIcon sx={{ color: '#d32f2f', height: '17px' }} />
                Delete Gateway
                </ListItem>
                 )} 
            </List>
        </Box>
    )

    const statusjsx = (id, align, value, ...other) => {
        let label = '';
        let boxStyles = {};

if (value === 0) {
    label = 'Inactive';
    boxStyles = {
        color: '#D19244',
        backgroundColor: 'rgba(209, 146, 68, 0.20)',
    };
} else if (value === 1) {
    label = 'Active';
    boxStyles = {
        color: '#50AB64',
        backgroundColor: 'rgba(40, 167, 69, 0.20)',
    };
} else if (value === 2) {
    label = 'Report Only';
    boxStyles = {
        color: '#D19244',
        backgroundColor: 'rgba(209, 146, 68, 0.20)',
    };
}

        return (
            <TableCell
                key={id}
                align={align}
                sx={{
                    borderBottom: '0.5px dashed',
                    borderColor: 'grey.300',
                    background: 'transparent',
                }}
            >
                <Box
                    sx={{
                        borderRadius: '6px',
                        fontWeight: 600,
                        fontSize: '14px',
                        display: 'inline-block',
                        ...boxStyles,
                        px: '12px',
                        py: '2px',
                    }}
                >
                    {label}
                </Box>
            </TableCell>
        );
    };
    const dedicatedJsx = (id, align, value, row) => {
    let tooltipText = '';
    let label = value === "Y" ? <InfoIcon /> : '-';
    if (value === "Y") {
        if (Array.isArray(row.allowed_user_ids) && row.allowed_user_ids.length > 0) {
            tooltipText = `Dedicated to: ${row.allowed_user_ids.join(', ')}`;
        } else {
            tooltipText = 'Dedicated gateway';
        }
    }
    


    return (
        <TableCell
            key={id}
            align={align}
            sx={{
                borderBottom: '0.5px dashed',
                borderColor: 'grey.300',
                background: 'transparent',
            }}
        >
            <Tooltip title={tooltipText} arrow>
                    {label}
            </Tooltip>
        </TableCell>
    );
};
 const createdatejsx = (id, align, value) => {
    const hasValue = value !== '' && value !== undefined && value !== null;
    const timestamp = Number(value);
    const date =
      hasValue && !Number.isNaN(timestamp)
        ? String(Math.trunc(timestamp)).length <= 10
          ? moment.unix(timestamp)
          : moment(timestamp)
        : null;
    const formattedDate = date?.format('D MMM, YYYY');
    const formattedTime = date?.format('h:mm A');

    return (
      <TableCell
        key={id}
        align={align}
        sx={{
          color: 'grey.700',
          borderBottom: '0.5px dashed',
          borderColor: 'grey.300',
        }}
      >
        <>
          <Box>{date?.isValid() ? `${formattedDate} ${formattedTime}` : '-'}</Box>
        </>
      </TableCell>
    );
  };
const routeJsx = (id, align, value) => {
    const ROUTE_LABELS = {
    transactional: "Transactional",
    promotional: "Promotional",
};
    const label = ROUTE_LABELS[value] || value;

    return (
        <TableCell
            key={id}
            align={align}
            sx={{
                borderBottom: '0.5px dashed',
                borderColor: 'grey.300',
                background: 'transparent',
            }}
        >
            {label}
        </TableCell>
    );
};

const cliTypeJsx = (id, align, value) => {
    const CLI_TYPE_LABELS = {
    1: "Shared",
    2: "Dedicated",
};
    const label = CLI_TYPE_LABELS[value] || value;

    return (
        <TableCell
            key={id}
            align={align}
            sx={{
                borderBottom: '0.5px dashed',
                borderColor: 'grey.300',
                background: 'transparent',
            }}
        >
            {label}
        </TableCell>
    );
};



    const ActionModals = () => {
        return (
            <CustomMenu
                anchorEl={anchorEl}
                handleClose={handleClose}
                Content={Content}
                 />
        )
    }
    return (
        <>
            <PaginationTable
                page={page}
                // tableFilter={tableFilter}
                ActionJsx={ActionJsx}
                ActionModals={ActionModals}
                setLoad={setLoad}
                setPage={setPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                count={count}
                error={networkError}
                loading={loading}
                setLoading={setLoading}
                rows={rows}
                columns={columns}
                handleChange={handleChange}
                search={search}
                calculatedHeight={288}
                status={statusjsx} 
                dedicatedJsx={dedicatedJsx}
                routeJsx={routeJsx}
                createdatejsx={createdatejsx}
                cliTypeJsx={cliTypeJsx}
            />
             <ConfirmDialog
            open={openStatus}
            onClose={handleCloseStatus}
            title="Change Status"
            content={
            <span>
            Are you sure you want to change status this Gateway {userData.gateway_id}. 
            <Select
            id="change-status"
            defaultValue={userData.status}
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            fullWidth
            sx={{
                marginTop: "10px",
                '& .MuiSelect-select': {
                paddingTop: '10px',
                paddingBottom: '10px',
                display: 'flex',
                alignItems: 'center',
                },
                '& .MuiOutlinedInput-notchedOutline': {
                padding: 0,
                },
            }}
            >
            {menuItems.map((item) => {
                return (
                <MenuItem
                    key={item.value}
                    value={item.value}
                    sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
                >
                    <span>{item.label}</span>
                </MenuItem>
                );
            })}
            </Select>

            </span>
            }
            action={
              <Button
                color="secondary"
                variant="contained"
                sx={{
                    color: '#fff',
                    height: '30px',
                    backgroundColor: 'primary.main',
                    '&:hover': {
                        backgroundColor: 'primary.main',
                    },
                    boxShadow: "none",
                    marginRight: '10px'
                }}
                    onClick={() => handleConfirmStatus(userData.gateway_id, status)}
                    >Confirm
            </Button>
            }
          />
             <ConfirmDialog
                      open={openAssign}
                      onClose={handleCloseAssign}
                      title="Assign Gateway"
                      content={
                      <span>
                          Are you sure you want to assign this Gateway {userData.gateway_id} to user.
                          <TextField
                          required
                          id="outlined-required"
                          label="User ID"
                          multiline
                          maxRows={4}
                          fullWidth
                          value={assign}
                          onChange={(e) => setAssign(e.target.value)}
                          sx={{ marginTop: "10px" }}
                          />
                      </span>
                      }
                      action={
                        <Button
                          color="secondary"
                          variant="contained"
                          sx={{
                              color: '#fff',
                              height: '30px',
                              backgroundColor: 'primary.main',
                              '&:hover': {
                                  backgroundColor: 'primary.main',
                              },
                              boxShadow: "none",
                              marginRight: '10px'
                          }}
                            onClick={() => handleConfirmAssign(userData.gateway_id, assign)}
                              >Confirm
                      </Button>
                      }
                    />
                    <ConfirmDialog
                      open={openRemoveAssign}
                      onClose={handleCloseRemoveAssign}
                      title="Remove Assignment"
                      content={
                      <span>
                          Are you sure you want to remove this Gateway {userData.gateway_id} from the user.
                          <TextField
                          required
                          id="outlined-required"
                          label="User ID"
                          multiline
                          maxRows={4}
                          fullWidth
                          value={removeAssign}
                          onChange={(e) => setRemoveAssign(e.target.value)}
                          sx={{ marginTop: "10px" }}
                          />
                      </span>
                      }
                      action={
                        <Button
                          color="secondary"
                          variant="contained"
                          sx={{
                              color: '#fff',
                              height: '30px',
                              backgroundColor: 'primary.main',
                              '&:hover': {
                                  backgroundColor: 'primary.main',
                              },
                              boxShadow: "none",
                              marginRight: '10px'
                          }}
                            onClick={() => handleConfirmRemoveAssign(userData.gateway_id)}
                              >Confirm
                      </Button>
                      }
                    />
                    <ConfirmDialog
            open={openTestGateway}
            onClose={()=>{setOpenTestGateway(false)}}
            title="Change Status"
            content={
            <span>
            Are you sure you want to change status this Gateway {userData.gateway_id}. 


            </span>
            }
            action={
              <Button
                color="secondary"
                variant="contained"
                sx={{
                    color: '#fff',
                    height: '30px',
                    backgroundColor: 'primary.main',
                    '&:hover': {
                        backgroundColor: 'primary.main',
                    },
                    boxShadow: "none",
                    marginRight: '10px'
                }}
                    onClick={() => handleConfirmStatus(userData.gateway_id, status)}
                    >Confirm
            </Button>
            }
          /> 
          
                <ConfirmDialog
                  open={openDelete}
                  onClose={handleCloseDelete}
                  title="Delete Gateway"
                  content={
                    <span>
                      Are you sure you want to delete this Gateway {userData.gateway_id}?
          
                    </span>
                  }
                  action={
                    <Button
                      color="secondary"
                      variant="contained"
                      sx={{
                        color: '#fff',
                        height: '30px',
                        backgroundColor: 'primary.main',
                        '&:hover': {
                          backgroundColor: 'primary.main',
                        },
                        boxShadow: "none",
                        marginRight: '10px'
                      }}
                      onClick={() => handleConfirmDelete()}
                    >Confirm
                    </Button>
                  }
                />
        </>
    )
}
